import React, { Component } from 'react';

import { FormControl } from 'components/form';
import {
  PreviewLogoThumbnail,
  PreviewBackgroundThumbnail,
  PreviewPresentationThumbnail,
  PreviewBackgroundAudioVideoThumbnail
} from 'components/svg/images';
import { I18n, translate } from 'components/translate';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import BackgroundMultipleUpload from 'modules/configManager/components/media/BackgroundMultipleUpload';
import BackgroundUpload from 'modules/content/components/media/BackgroundUpload';
import { FileService } from 'modules/file';
import {
  ENTITY_TYPE,
  MAX_MEMBERSHIP_LOGO_SIZE,
  MAX_MEMBERSHIP_BACKGROUND_SIZE,
  MAX_MEMBERSHIP_PRESENTATION_SIZE,
  MAX_MEMBERSHIP_BACKGRD_AUDIO_VIDEO_SIZE
} from 'modules/file/constants';
import { UiService } from 'modules/ui';
import { PropTypes } from 'prop-types';

import './ConfigCustomization.scss';

@translate()
@inject('ConfigStore', 'MembershipStore')
@observer
export default class ConfigCustomizationImages extends Component {
  static propTypes = {
    ConfigStore: MobxPropTypes.objectOrObservableObject,
    MembershipStore: MobxPropTypes.objectOrObservableObject,
    t: PropTypes.func
  };

  onError = (message, data) => UiService.setAlertError(message, data);

  render() {
    const { hasStreamingBackground } = this.props.MembershipStore;
    const { images } = this.props.ConfigStore.custom;

    const {
      logoImageId,
      presentationImageId,
      backgroundImageId,
      backgroundAudioVideo
    } = images || {};

    return (
      <div
        className="grid grid__block custom__background--upload"
        data-test="settings-customization-images"
      >
        <h2>
          <I18n label="general.images" />
        </h2>

        <FormControl>
          <BackgroundUpload
            description="config_manager.config_custom.images.logo_description"
            labelValue="general.logo"
            placeholderImg={PreviewLogoThumbnail}
            entity={ENTITY_TYPE.MEMBERSHIP_LOGO}
            onCancelUpload={FileService.onCancelUpload}
            maxFileSize={MAX_MEMBERSHIP_LOGO_SIZE}
            maxHeight={70}
            value={logoImageId && logoImageId[0]}
            name="logoImageId"
            className="custom__options"
            setCentralError={this.onError}
          />
        </FormControl>

        <FormControl>
          <BackgroundUpload
            description="config_manager.config_custom.images.background"
            labelValue="general.background_image"
            placeholderImg={PreviewBackgroundThumbnail}
            onCancelUpload={FileService.onCancelUpload}
            entity={ENTITY_TYPE.MEMBERSHIP_BACKGROUND}
            maxFileSize={MAX_MEMBERSHIP_BACKGROUND_SIZE}
            value={backgroundImageId && backgroundImageId[0]}
            name="backgroundImageId"
            className="custom__options"
            setCentralError={this.onError}
          />
        </FormControl>

        <FormControl>
          <BackgroundUpload
            description="config_manager.config_custom.images.presentation"
            labelValue="general.presentation_image"
            placeholderImg={PreviewPresentationThumbnail}
            onCancelUpload={FileService.onCancelUpload}
            entity={ENTITY_TYPE.MEMBERSHIP_PRESENTATION}
            maxFileSize={MAX_MEMBERSHIP_PRESENTATION_SIZE}
            maxHeight={128}
            maxWidth={600}
            value={presentationImageId && presentationImageId[0]}
            name="presentationImageId"
            className="custom__options"
            setCentralError={this.onError}
          />
        </FormControl>

        {hasStreamingBackground && (
          <FormControl>
            <BackgroundMultipleUpload
              description="config_manager.config_custom.images.media_background"
              labelValue="general.media_background_image"
              placeholderImg={PreviewBackgroundAudioVideoThumbnail}
              entity={ENTITY_TYPE.MEMBERSHIP_BACKGRD_AUDIO_VIDEO}
              onCancelUpload={FileService.onCancelUpload}
              maxFileSize={MAX_MEMBERSHIP_BACKGRD_AUDIO_VIDEO_SIZE}
              maxHeight={1920}
              maxWidth={750}
              value={backgroundAudioVideo}
              name="backgroundAudioVideo"
              className="custom__options"
              setCentralError={this.onError}
            />
          </FormControl>
        )}
      </div>
    );
  }
}
